/**
 * @generated SignedSource<<0cd347b76085f1a0dbadb8ac3d04b761>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type pantoneLibraryDialogImportDefaultPaletteMutation$variables = {
  id: string;
};
export type pantoneLibraryDialogImportDefaultPaletteMutation$data = {
  readonly importDefaultPalette: string;
};
export type pantoneLibraryDialogImportDefaultPaletteMutation = {
  response: pantoneLibraryDialogImportDefaultPaletteMutation$data;
  variables: pantoneLibraryDialogImportDefaultPaletteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "importDefaultPalette",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pantoneLibraryDialogImportDefaultPaletteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pantoneLibraryDialogImportDefaultPaletteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b25bc2ab49e9ee312537faaefb475ea3",
    "id": null,
    "metadata": {},
    "name": "pantoneLibraryDialogImportDefaultPaletteMutation",
    "operationKind": "mutation",
    "text": "mutation pantoneLibraryDialogImportDefaultPaletteMutation(\n  $id: ID!\n) {\n  importDefaultPalette(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "64b30b204901b00069fa6d8bcc12c40f";

export default node;
